(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-you-like"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.we-think-you-like');
    sections.forEach((section) => {
      const slider = section.querySelector('.we-think-slider');
      const prevBtn = section.querySelector('.prev-arrow');
      const nextBtn = section.querySelector('.next-arrow');

      if (slider && prevBtn && nextBtn) {
        nextBtn.addEventListener('click', () => {
          const cardWidth = slider.querySelector('.we-think-card').offsetWidth;
          slider.scrollBy({ left: cardWidth + 15, behavior: 'smooth' });
        });

        prevBtn.addEventListener('click', () => {
          const cardWidth = slider.querySelector('.we-think-card').offsetWidth;
          slider.scrollBy({ left: -(cardWidth + 15), behavior: 'smooth' });
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
